<template>
    <section id="master-share-quiz" class="layout layout-scale" :class="{ 'opacity-0': !isAlreadyShow }">
        <div class="header pb-3 md:pb-0">
            <div class="text-center md:hidden">
                <HeaderLogo
                    :warning-message="warningMessage"
                    logo-width="12"
                    color="var(--ui-color)"
                    shadow="var(--question-shadow-color)"
                    class="logo inline-block"
                ></HeaderLogo>
            </div>
            <div class="hidden md:flex">
                <HeaderLogo
                    :warning-message="warningMessage"
                    logo-width="12"
                    color="var(--ui-color)"
                    shadow="var(--question-shadow-color)"
                ></HeaderLogo>
            </div>
            <div v-if="!joinAsPlayer" class="absolute setting-btn text-center text-white flex">
                <div @click="openLiveShare()" class="flex justify-center items-center mr-4 cursor-pointer">
                    <i id="share-summary" class="theme-ui-text-color theme-question-shadow fas fa-tv font-size-18"></i>
                </div>
                <div class="flex justify-center items-center cursor-pointer" @click="handleShowQuizSetting">
                    <i class="theme-ui-text-color theme-question-shadow fas fa-cog font-size-18 md:mr-2"></i>
                    <h2 class="theme-ui-text-color theme-question-shadow font-size-16 hidden sm:block">
                        {{ $t('playlive_button_setting') }}
                    </h2>
                </div>
            </div>
        </div>
        <div class="content xl:flex xl:items-center">
            <div class="content-container relative mx-auto h-full">
                <div class="box">
                    <div class="mb-4 xl:mb-10 text-center text-white" id="code">
                        <h1
                            class="theme-question-text-color theme-question-shadow font-size-18 md:font-size-38 mb-2 mt-0 mb-3 text-center"
                        >
                            {{ title }}
                        </h1>
                        <!-- <h2 class="text-white font-normal font-size-16 md:font-size-18 mt-0 mb-4 whitespace-pre-wrap" v-html="description"></h2> -->
                        <div style="padding: 0px 8.706%">
                            <div class="qrcode-container inline-block mx-auto">
                                <div @click.prevent="copyShareLink" class="flip-qrcode mx-auto cursor-pointer">
                                    <div class="flip-qrcode-inner">
                                        <div
                                            class="flip-qrcode-front"
                                            :style="`background-image: url(${
                                                image ? image : getQuizImage(currentQuiz, true)
                                            }); background-color: ${
                                                getQuiz.theme_name
                                                    ? getQuiz.themes[getQuiz.theme_name].background_color
                                                    : backgroundColor
                                            }`"
                                        ></div>
                                        <div class="flip-qrcode-back">
                                            <qrcanvas
                                                :class="{
                                                    'qrcode w-full h-full rounded border-8 border-solid border-white': true,
                                                    show: isShowQrCode
                                                }"
                                                :options="qrCodeOptions"
                                            ></qrcanvas>
                                        </div>
                                    </div>
                                </div>
                                <a
                                    @click.prevent="copyShareLink"
                                    class="flex-1 flex flex-col items-center no-underline cursor-pointer"
                                >
                                    <p
                                        class="text-black shadow-text-none font-size-16 md:font-size-18 xl:font-size-22 font-bold"
                                    >
                                        {{ baseUrl.replace('http://', '').replace('https://', '') }}join
                                    </p>
                                    <p
                                        class="text-black shadow-text-none font-size-24 md:font-size-30 xl:font-size-34 font-bold text-5xl leading-none"
                                    >
                                        {{ code }}
                                    </p>
                                </a>
                            </div>
                        </div>
                        <p
                            class="theme-question-text-color theme-question-shadow mt-1 text-under-qrcode font-size-12 xl:font-size-16"
                        >
                            {{ $t('playlive_share_qr_description') }}
                        </p>
                        <p
                            class="theme-question-text-color theme-question-shadow font-bold font-size-18 md:font-size-24 break-words"
                        >
                            {{ customMessage }}
                        </p>
                    </div>
                    <div class="theme-question-text-color text-center text-white">
                        <p class="theme-question-shadow font-bold font-size-26 xl:font-size-30 uppercase">
                            {{ users.length }} <span v-if="limitPlayer"></span> {{ $t('playlive_share_joined') }}
                        </p>
                    </div>
                </div>

                <div class="box">
                    <div class="relative py-2 md:py-0 w-full h-full">
                        <!-- Begin list Mobile -->
                        <div class="mobile text-center">
                            <ul class="list-reset my-0 md:mt-4 overflow-y-auto" v-if="users.length > 0">
                                <template v-for="(user, userIndex) in users">
                                    <li
                                        :class="{
                                            'theme-ui-text-color text-white font-bold uppercase font-size-22 md:inline-block': true,
                                            'md:mr-4': users.length > 1
                                        }"
                                        :key="user.id"
                                        v-if="userIndex < 6"
                                    >
                                        <span class="theme-question-shadow">{{ user }}</span>
                                    </li>
                                </template>
                                <li
                                    class="theme-ui-text-color text-white font-bold uppercase font-size-22 md:mt-1"
                                    v-if="users.length > 6"
                                >
                                    <a
                                        href="#"
                                        class="theme-question-shadow text-white"
                                        @click="isShowMorePlayerPopup = true"
                                        >{{ users.length - 6 }} {{ $t('playlive_share_more') }}</a
                                    >
                                </li>
                            </ul>
                            <ul v-else class="list-reset my-0 overflow-y-auto opacity-0">
                                <li
                                    class="theme-ui-text-color text-white font-bold uppercase font-size-22"
                                    :key="`mock-list-${n}`"
                                    v-for="n in 7"
                                >
                                    <span class="theme-question-shadow">{{ n }}</span>
                                </li>
                            </ul>
                        </div>
                        <!-- End list Mobile -->

                        <!-- Begin list Desktop -->
                        <div class="desktop w-full h-full py-3 pl-10">
                            <ul class="list-reset overflow-x-auto whitespace-no-wrap w-full h-full m-0">
                                <li
                                    v-for="user in users"
                                    class="theme-ui-text-color mb-4 text-white uppercase font-size-28"
                                    :key="user.id"
                                >
                                    <span class="theme-question-shadow">{{ user }}</span>
                                </li>
                            </ul>
                        </div>
                        <!-- End list Desktop -->
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="flex items-center flex-col justify-center w-full">
                <button
                    :disabled="!canStart || !questions.length"
                    id="start-quiz-btn"
                    class="theme-button btn font-size-22 font-opensans btn-large uppercase mb-3 md:mb-0"
                    @click="handleClickStart"
                >
                    {{
                        $t('playlive_share_button_start', {
                            type: type != 'quiz' ? $t('playlive_share_type_poll') : $t('playlive_share_type_quiz')
                        })
                    }}
                </button>
                <span
                    :disabled="!canStart"
                    class="theme-ui-text-color theme-question-shadow font-size-16 md:font-size-18 uppercase text-white font-bold cursor-pointer md:hidden"
                    @click="handleClickCancel"
                    >{{
                        $t('playlive_button_cancel', {
                            type: type != 'quiz' ? $t('playlive_share_type_poll') : $t('playlive_share_type_quiz')
                        })
                    }}</span
                >
            </div>
            <!-- Begin Desktop footer -->
            <DesktopFooter>
                <template slot="left">
                    <div class="flex items-end h-12">
                        <a
                            class="theme-ui-text-color cursor-pointer text-white font-size-18 uppercase flex items-center font-bold"
                            @click="toggleFullScreen"
                            type="button"
                        >
                            <i
                                v-if="isFullscreen"
                                class="theme-question-shadow fas fa-compress-arrows-alt font-size-22 mr-1"
                            ></i>
                            <!-- <span v-if="isFullscreen">{{ $t('playlive_button_exit_fullscreen') }} </span> -->
                            <i
                                v-if="!isFullscreen"
                                class="theme-question-shadow fas fa-expand-arrows-alt font-size-22 mr-1"
                            ></i>
                            <!-- <span v-if="!isFullscreen">{{ $t('playlive_button_fullscreen') }}</span> -->
                        </a>
                    </div>
                </template>
                <template slot="right">
                    <div class="flex items-end justify-end h-full">
                        <a
                            @click="handleClickCancel"
                            class="theme-ui-text-color uppercase text-white font-bold cursor-pointer font-size-18 inline-flex items-center"
                        >
                            <!-- <span>{{
                                $t('playlive_button_cancel', {
                                    type:
                                        type != 'quiz' ? $t('playlive_share_type_poll') : $t('playlive_share_type_quiz')
                                })
                            }}</span> -->
                            <i class="theme-question-shadow fas fa-times font-size-28 ml-1"></i>
                        </a>
                    </div>
                </template>
            </DesktopFooter>
            <!-- End Desktop footer -->
        </div>

        <quiz-setting-modal
            v-if="showQuizSettingModal"
            :delayAnswer="delayAnswer"
            :delayQuestion="delayQuestion"
            :timeLimit="timeLimit"
            :masterSound="masterSound"
            :playerSound="playerSound"
            :progress-bar-status="progressBarStatus"
            :masterResultSetting="masterResultSetting"
            @close="handleQuizSetting"
        ></quiz-setting-modal>

        <SeeMorePlayerPopup v-if="isShowMorePlayerPopup" :players="users" @close="isShowMorePlayerPopup = false" />

        <PaymentPopup
            v-if="showPaymentPopup"
            @close="showPaymentPopup = false"
            @success="paymentSuccess"
            :payment-title="$t('purchase_header_upgrade')"
            :quiz-id="id"
        />
    </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import swal from 'sweetalert'
import Qrcanvas from 'qrcanvas-vue'
import appConfig from '@/app.config.js'
import { currentUser, isLoggedIn } from '@/lib/user'
import HeaderLogo from '@/components/HeaderLogo.vue'
import DesktopFooter from '@/components/DesktopFooter.vue'
import SeeMorePlayerPopup from '@/components/SeeMorePlayerPopup.vue'
import popup from '@/lib/popup.js'
import Background from '@/lib/background.js'
import FullScreen from '@/lib/fullscreen.js'
import helper from '@/lib/helper.js'
import qrcodeBackImage from '../assets/bg-back-qrcode.png'
import preloadImageMixin from '@/mixins/preload-image'
import preloadSongMixin from '@/mixins/preload-song'
import Request from '@/lib/request.js'
import QuizSettingModal from '@/components/QuizSettingModal.vue'
import socketConnectionMixin from '@/mixins/socket-connection.js'
import helperMixins from '@/mixins/helper.js'
import helperLiveQuiz from '@/mixins/helper-live-quiz.js'
import { startIntroMasterShare } from '@/lib/intro.js'
import introJsData from '@/mixins/introjs-data'
import PaymentPopup from '@/components/PaymentPopup.vue'

export default {
    mixins: [preloadImageMixin, preloadSongMixin, socketConnectionMixin, helperMixins, helperLiveQuiz, introJsData],

    components: {
        Qrcanvas,
        HeaderLogo,
        DesktopFooter,
        SeeMorePlayerPopup,
        QuizSettingModal,
        PaymentPopup
    },

    sockets: {
        user_joined_waiting_count: function (users) {
            this.users = users.reverse()

            if (this.users.length) {
                if (!this.playBoxAnimation) {
                    const leftBox = document.querySelectorAll('.box')[0]
                    const rightBox = document.querySelectorAll('.box')[1]

                    leftBox.style.transform = `translate(calc(-50% - (${leftBox.offsetWidth}px / 2) - 40px), -50%)`
                    rightBox.style.transform = `translate(calc(50% + (${rightBox.offsetWidth}px / 2) + 40px), -50%) scale(.9)`

                    setTimeout(() => {
                        rightBox.style.opacity = 1
                        rightBox.style.filter = 'blur(0px)'
                        rightBox.style.transform = `translate(calc(50% + (${rightBox.offsetWidth}px / 2) + 40px), -50%) scale(1)`
                    }, 500)

                    this.playBoxAnimation = true
                }

                var clone = this.audioDifinite.cloneNode()
                if (this.masterSound.effectMusic) {
                    clone.play()
                }

                if (helper.iOS()) {
                    if (this.masterSound.effectMusic) {
                        this.audioDifinite.play()
                    }
                }
            }

            this.updateQuestions()
        },

        master_ended_game: function () {
            this.$router.replace({
                name: 'redirect-setting',
                params: {
                    id: this.id
                }
            })
        },

        user_ended_game: function (data) {
            this.$store.commit('updatePlayerCount', data.users.length)
            this.users = data.users

            if (!this.users.length) {
                const leftBox = document.querySelectorAll('.box')[0]
                const rightBox = document.querySelectorAll('.box')[1]

                rightBox.style.opacity = 0
                rightBox.style.filter = 'blur(2px)'
                rightBox.style.transform = `translate(calc(50% + (${rightBox.offsetWidth}px / 2) + 40px), -50%) scale(.9)`
                leftBox.style.transform = `translate(-50%, -50%)`

                this.playBoxAnimation = false
            }

            this.updateQuestions()
        },

        master_send_user_limit: function (data) {
            this.limitPlayer = data.limit_player
        },

        master_user_over_limit: function () {
            this.showAlertLimitPLayer()
        },

        master_pressed_start: function (data) {
            if (data.playing_type == 'play_together') {
                this.$router.push({
                    name: 'countdown',
                    params: {
                        code: data.room,
                        name: 'join-start'
                    }
                })
            }
        },

        master_clear_other_window: function () {
            popup.alert(this.$t('playlive_share_alert_started_another'), () => {
                window.location.href = this.$router.resolve({ name: 'my-quiz' }).href
            })
        }
    },

    mounted: function () {
        this.touchActionNone()

        let localSetting = JSON.parse(localStorage.getItem('live-quiz-setting'))
        if (localSetting) {
            this.$store.commit('updateDelayAnswer', localSetting.delayAnswer)
            this.$store.commit('updateDelayQuestion', localSetting.delayQuestion)
            this.$store.commit('updateTimeLimit', localSetting.timeLimit)
            this.$store.commit('updateMasterSound', localSetting.masterSound)
            this.$store.commit('updatePlayerSound', localSetting.playerSound)
            this.$store.commit('updateProgressBarStatus', localSetting.progressBarStatus)
            this.$store.commit('updateMasterResultSetting', localSetting.masterResultSetting)

            this.setSocketSetting()
        }

        window.onbeforeunload = function () {
            return 'Are you sure you want to leave this page? You will loose any unsaved actions'
        }

        this.$socket.emit('user_joined_waiting', {
            room: this.code
        })

        this.$socket.emit('master_get_user_limit', {
            room: this.code
        })

        this.$socket.emit('master_set_playing_as', {
            room: this.code,
            playing_as: this.joinAsPlayer ? 'player' : 'master'
        })

        window.addEventListener('unload', this.handleUserCloseWindow)

        new Background({
            color: this.getQuiz.theme_name
                ? this.getQuiz.themes[this.getQuiz.theme_name].background_color
                : this.backgroundColor,
            image: this.getQuiz.theme_name
                ? this.getQuiz.themes[this.getQuiz.theme_name].background_image
                : this.backgroundImage,
            type: this.backgroundType,
            blur: this.blur,
            darken: this.darken,
            navText: this.frontPageSetting.nav_text,
            useTheme: this.getQuiz.theme_name ? true : false
        })

        setTimeout(() => {
            this.isShowQrCode = true
        }, 1400)

        this.findOrderAbility()
        this.checkHasSong()

        // Receive custom event componentAlready
        window.addEventListener('componentAlready', () => {
            if (this.$route.name === 'share') {
                this.resizeScaleQuizFrame()
            }
        })

        this.$store.dispatch('getQuizRelateCategory', { tags: this.tags, quiz_id: this.fromQuizIdPlayer })
        this.$store.commit('setCacheQuestions', this.questions)

        setTimeout(() => {
            startIntroMasterShare(this.stepTour5)
        }, 1000)
    },

    destroyed() {
        window.onbeforeunload = function () {}
    },

    data: function () {
        return {
            baseUrl: appConfig.shortBaseUrl,
            users: [],
            fullscreen: new FullScreen('.app-wrapper'),
            audioStack: [],
            countPlay: 0,
            isShowQrCode: false,
            qrcodeBackImage: qrcodeBackImage,
            isFullscreen: false,
            limitPlayer: 0,
            isShowMorePlayerPopup: false,
            isAlreadyShow: false,
            isClickStart: false,
            showQuizSettingModal: false,
            playBoxAnimation: false,
            showPaymentPopup: false
        }
    },

    methods: {
        setSocketSetting() {
            this.$socket.emit('master_toggle_play_song_user', {
                room: this.code,
                player_sound: this.playerSound,
                delay_answer: this.delayAnswer,
                delay_question: this.delayQuestion,
                time_limit: this.timeLimit,
                progress_bar_status: this.progressBarStatus
            })

            this.$socket.emit('master_set_setting', {
                room: this.code,
                player_sound: this.playerSound,
                delay_answer: this.delayAnswer,
                delay_question: this.delayQuestion,
                time_limit: this.timeLimit,
                masterSound: this.masterSound,
                progress_bar_status: this.progressBarStatus,
                masterResultSetting: this.masterResultSetting
            })

            if (this.joinAsPlayer) {
                this.$store.commit('player/toggleQuizPlayerSound', this.playerSound)
                this.$store.commit('player/updateDelayAnswer', this.delayAnswer)
                this.$store.commit('player/updateDelayQuestion', this.delayQuestion)
                this.$store.commit('player/updateTimeLimit', this.timeLimit)
                this.$store.commit('player/updateProgressBarStatus', this.progressBarStatus)
            }
        },

        handleUserCloseWindow: function () {
            this.$socket.emit('master_end_game', {
                room: this.code
            })
        },

        handleShowQuizSetting() {
            this.showQuizSettingModal = true
        },

        handleQuizSetting(answerDelay, questionDelay, timeLimit, master, player, progressBarStatus, masterResult) {
            let liveQuizSetting = {
                delayAnswer: answerDelay,
                delayQuestion: questionDelay,
                timeLimit: timeLimit,
                masterSound: master,
                playerSound: player,
                progressBarStatus: progressBarStatus,
                masterResultSetting: masterResult
            }
            localStorage.setItem('live-quiz-setting', JSON.stringify(liveQuizSetting))
            this.$store.commit('updateDelayAnswer', answerDelay)
            this.$store.commit('updateDelayQuestion', questionDelay)
            this.$store.commit('updateTimeLimit', timeLimit)
            this.$store.commit('updateMasterSound', master)
            this.$store.commit('updatePlayerSound', player)
            this.$store.commit('updateProgressBarStatus', progressBarStatus)
            this.$store.commit('updateMasterResultSetting', masterResult)
            this.setSocketSetting()
            this.showQuizSettingModal = false
        },

        handleClickStart: function (e) {
            if (!this.questions.length) return

            document.querySelector('#start-quiz-btn').style.pointerEvents = 'none'

            if (this.isClickStart) {
                return
            }

            this.isClickStart = true

            if (!this.users.length) {
                e.preventDefault()
                return
            }

            const playingType = this.joinAsPlayer ? 'play_together' : 'user_quiz'
            var masterName = playingType == 'play_together' ? 'Master' : ''

            if (isLoggedIn()) {
                masterName = helper.shortName(currentUser().name)
                const request = new Request()

                // set play type count
                request.post(appConfig.api.setUserPlayType.replace(/__id__/, currentUser().id), {
                    playing_type: 'play_together'
                })
            }

            this.handleQuizSetting(
                this.delayAnswer,
                this.delayQuestion,
                this.timeLimit,
                this.masterSound,
                this.playerSound,
                this.progressBarStatus,
                this.masterResultSetting
            )

            this.$socket.emit('master_press_start', {
                room: this.code,
                name: masterName,
                playing_type: playingType,
                master_playing_as: this.joinAsPlayer ? 'player' : 'master'
            })

            this.$store.commit('updatePlayerCount', this.users.length)
            this.preloadRankingImage()

            const code = this.parentQuizCode || this.code

            helper.gTrackEvent('play', {
                event_category: 'PlayLive',
                event_label: `StartPlay_${code}_live`
            })

            if (playingType !== 'play_together') {
                this.$router.push({
                    name: 'master-countdown',
                    params: {
                        name: 'master-result'
                    }
                })
            } else {
                this.$store.commit('player/updatePlayerName', masterName)
            }

            this.$store.dispatch('saveQuizPlaying', {
                quiz_id: this.id ? this.id : this.id.$oid,
                quiz_type: this.type,
                user_id: currentUser().id,
                quiz_created_by: this.id ? 'admin' : 'user',
                playing_type: this.id ? 'play_together' : 'user_quiz'
            })
        },

        handleClickCancel: function () {
            const self = this

            window.onbeforeunload = function () {}

            popup.confirm(
                this.$t('playlive_share_alert_cancel', {
                    type:
                        self.type != 'quiz' ? this.$t('playlive_share_type_poll') : this.$t('playlive_share_type_quiz')
                }),
                function () {
                    self.$socket.emit('master_end_game', {
                        room: self.code
                    })

                    window.location.href = '/edit/' + self.id + (self.isPlayTogether ? '?type=pt' : '')
                },
                function () {
                    window.onbeforeunload = function () {
                        return 'Are you sure you want to leave this page? You will loose any unsaved actions'
                    }
                }
            )
        },

        findOrderAbility() {
            this.$store.dispatch('findOrderAbility')
        },

        checkHasSong() {
            this.preloadNextSong(this.questions[0])
        },

        copyShareLink() {
            // If browser support native share link
            if (window.navigator.share) {
                navigator
                    .share({
                        title: 'TheBigQuiz',
                        text: `Join ${this.title} - TheBigQuiz`,
                        url: this.shareLink
                    })
                    .then(() => {})
            } else {
                navigator.clipboard
                    .writeText(this.shareLink)
                    .then(() => {
                        popup.alert(this.$t('playlive_share_alert_link_copied'), () => {}, {
                            icon: 'success'
                        })
                    })
                    .catch(() => {
                        popup.alert(this.$t('playlive_share_alert_link_copied_error'), () => {}, {
                            icon: 'error'
                        })
                    })
            }
        },

        updateQuestions() {
            if (
                !this.isFrontPageQuiz &&
                this.type != 'poll' &&
                !this.orderAbility.has_subscribed &&
                !this.orderAbility.is_24hrs_access &&
                this.users.length > 2
            ) {
                this.$store.commit(
                    'updateQuestionList',
                    this.questions.filter(e => e.question_type == 'basic')
                )
            } else {
                this.$store.commit('updateQuestionList', this.$store.state.cacheQuestions)
            }

            this.$socket.emit('master_update_questions', this.$store.state.question)
        },

        openLiveShare() {
            window.open(`/live/${this.code}`, '_blank')
        },

        async showAlertLimitPLayer() {
            const message = this.$t('join_over_limit_master')
            const swalOption = {
                closeOnClickOutside: false,
                buttons: {
                    confirm: {
                        text: this.$t('payment_button_upgrade'),
                        value: true,
                        className: 'btn font-opensans text-md system-button-color system-button-text-color'
                    },
                    cancel: {
                        text: this.$t('playlive_button_cancel'),
                        visible: true,
                        value: false,
                        className: 'btn default font-opensans text-md'
                    }
                }
            }

            const upgrade = await swal(message, swalOption)

            if (upgrade) {
                this.showPaymentPopup = true
            }
        },

        paymentSuccess(payload) {
            this.$socket.emit('master_make_payment_success', {
                user_id: currentUser().id,
                order_id: payload.order_id,
                room: this.code
            })

            this.$store.dispatch('findOrderAbility')
        }
    },

    computed: {
        ...mapGetters({
            audioDifinite: 'getDifiniteAudio',
            parentQuizCode: 'parentQuizCode',
            delayAnswer: 'getDelayAnswer',
            delayQuestion: 'getDelayQuestion',
            timeLimit: 'getTimeLimit',
            masterSound: 'getMasterSound',
            playerSound: 'getPlayerSound',
            progressBarStatus: 'getProgressBarStatus',
            masterResultSetting: 'getMasterResultSetting',
            getQuiz: 'getQuiz'
        }),

        ...mapState({
            id: state => state.question._id,
            title: state => state.question.title,
            code: state => state.question.code,
            type: state => state.question.type,
            image: state => state.question.image,
            description: state => state.question.description,
            qrCodeOptions: state => state.qrCodeOptions,
            backgroundType: state => state.question.background_type,
            backgroundImage: state => state.question.background_image,
            blur: state => state.question.background_image_blur,
            darken: state => state.question.background_image_darken,
            backgroundColor: state => state.question.background_color,
            customMessage: state => state.question.custom_message,
            fromQuizId: state => state.question.from_quiz_id,
            joinAsPlayer: state => state.player.joinAsPlayer,
            isPlayTogether: state => state.player.isPlayTogether,
            frontPageSetting: state => state.frontPageSetting,
            tags: state => state.player.quiz.tags,
            fromQuizIdPlayer: state => state.player.quiz.from_quiz_id,
            questions: state => state.question.questions,
            orderAbility: state => state.orderAbility,
            isFrontPageQuiz: state => state.question.is_frontpage_quiz
        }),

        canStart() {
            if (this.$route.query.type == 'pt') {
                return this.users.length >= 2
            }

            return this.users.length
        },

        shareLink() {
            if (currentUser().share_code) {
                let shareCode = currentUser().share_code

                return `${appConfig.shortBaseUrl}join/${this.code}/share?u=${shareCode}`
            }

            return `${appConfig.shortBaseUrl}join/${this.code}/share`
        },

        warningMessage() {
            return this.$t('playlive_share_alert_leave', {
                type: this.type != 'quiz' ? this.$t('playlive_share_type_poll') : this.$t('playlive_share_type_quiz')
            })
        },

        currentQuiz() {
            return this.$store.state.question
        }
    },

    beforeRouteLeave(to, from, next) {
        let self = this

        window.onbeforeunload = function () {}

        if (
            to.name === 'master-countdown' ||
            to.name === 'countdown' ||
            to.name === 'join' ||
            to.name == 'my-quiz' ||
            to.name == 'redirect-setting'
        ) {
            next()
        } else {
            next(false)
            popup.confirm(
                this.$t('playlive_share_alert_leave', {
                    type:
                        this.type != 'quiz' ? this.$t('playlive_share_type_poll') : this.$t('playlive_share_type_quiz')
                }),
                function () {
                    self.$store.dispatch('pauseNoSleep')

                    self.$socket.emit('master_end_game', {
                        room: self.code
                    })

                    next()
                },
                function () {
                    window.onbeforeunload = function () {
                        return 'Are you sure you want to leave this page? You will loose any unsaved actions'
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
#master-share-quiz {
    .logo {
        @media (max-width: 768px) {
            max-width: 9rem !important;
        }
    }

    .content-container {
        width: 100%;
        min-height: 700px;
        column-gap: 40px;
        transform-origin: unset !important;

        @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
            max-width: 50rem;
            height: auto;
            display: block;
        }

        @media screen and (max-width: 1199px) {
            transform-origin: center top !important;
        }

        .box {
            position: absolute;
            top: 50%;
            width: auto;
            height: 90%;
            aspect-ratio: 2 / 3;
            padding: 2.12% 1.49%;
            background-color: rgba(0, 0, 0, 0.3);
            border-radius: 3.3%/2.6%;
            overflow: hidden;

            @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                position: unset;
                width: auto;
                height: auto;
                aspect-ratio: unset;
                margin: 0 auto;
                padding: 0;
                background-color: unset;
                border-radius: 1rem;
            }

            &:first-of-type {
                left: 50%;
                transform: translate(-50%, -50%);
                transition: transform 0.5s ease;

                @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                    position: unset !important;
                    transform: unset !important;
                }
            }

            &:last-of-type {
                right: 50%;
                transform: translate(calc(50% + 250px + 40px), -50%) scale(0.9);
                opacity: 0;
                filter: blur(2px);
                transition: opacity 0.5s ease, filter 0.5s ease, transform 0.5s ease;

                @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                    position: unset !important;
                    transform: unset !important;
                }

                .mobile {
                    display: none;

                    @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                        display: block;
                    }
                }

                .desktop {
                    display: block;

                    @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                        display: none;
                    }
                }
            }

            h1 {
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-word;
            }

            ul {
                &::-webkit-scrollbar {
                    width: 10px;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    background-color: rgba(255, 255, 255, 0.2);
                }
            }
        }
    }
}

.setting-btn {
    top: 1.5rem;
    right: 1rem;
}

.qrcode-container {
    width: 100%;
    background-color: white;
    border-radius: 3%;
    padding: 4.22% 5.274%;

    @media screen and (max-width: 1199px) and (orientation: portrait) {
        width: auto;
        padding: 0.5rem 0.75rem 0.75rem 0.75rem;
        border-radius: 0.75rem;
    }
}

.flip-qrcode {
    perspective: 1000px;
    aspect-ratio: 1 / 1;
    width: 100% !important;
    height: auto !important;

    @media screen and (max-width: 1199px) and (orientation: portrait) {
        width: 16rem !important;
    }

    @media screen and (max-width: 767px) {
        width: 12rem !important;
    }

    .flip-qrcode-inner {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        transform-style: preserve-3d;
        border-radius: 0.75rem;
        // background-image: url('../assets/bg-back-qrcode.png');
        background-size: cover;
        background-position: center;

        animation-duration: 1.3s;
        animation-delay: 1.3s;
        animation-fill-mode: both;
        animation-name: flipQrCode;

        @keyframes flipQrCode {
            0% {
                transform: rotateY(0);
            }
            100% {
                transform: rotateY(-180deg);
            }
        }

        .flip-qrcode-front,
        .flip-qrcode-back {
            position: absolute;
            width: 100% !important;
            height: 100% !important;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
        }

        .flip-qrcode-front {
            border-radius: 2%;
            background-color: var(--legacy-text-color);
            background-image: url('../assets/bg-back-qrcode.png');
            background-size: cover;

            @media (max-width: 767px) {
                width: calc(100% - 0.75rem);
                height: calc(100% - 0.75rem);
                border-radius: 0.25rem;
            }
        }
        .flip-qrcode-back {
            background-image: url('../assets/frame.png');
            background-size: cover;
            transform: translate(-50%, -50%) rotateY(180deg);
            border-radius: 0.25rem;

            .qrcode {
                opacity: 0;
                transition: 0.3s;

                &.show {
                    opacity: 1;
                }
            }
        }
    }
}

.quick_replies {
    display: inline-block;
    clear: both;
    padding: 10px;
    border-radius: 30px;
    margin-bottom: 2px;
    font-family: Helvetica, Arial, sans-serif;
    border: solid 2px #86bb71;
}

.layout {
    height: calc(100vh - 2rem);
    height: calc((var(--vh, 1vh) * 100) - 2rem);
}

.btn {
    padding: 0.6rem 1.5rem;
}

@media screen and (min-width: 768px) and (max-width: 1920px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }
}

@media screen and (min-width: 768px) {
    // section.layout .content {
    //     overflow-y: inherit;
    //     overflow-x: inherit;
    // }
}

@media screen and (max-width: 767px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }

    section.layout .footer {
        padding-bottom: 0;
        bottom: 0;
    }
}
</style>
